/* eslint-disable no-nested-ternary */
import getConfig from 'next/config';

const {
  publicRuntimeConfig: { envVars },
} = getConfig();

const { ENVIRONMENT } = envVars;

export const erDomain = {
  en:
    ENVIRONMENT == 'development'
      ? 'eaglerider.lcom'
      : ENVIRONMENT == 'prelive'
        ? 'prelive-www.eaglerider.com'
        : 'www.eaglerider.com'
};
